var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.5 0.363281C6.97512 0.363281 0.875 6.4634 0.875 13.9883C0.875 21.5132 6.97512 27.6133 14.5 27.6133C22.0249 27.6133 28.125 21.5132 28.125 13.9883C28.1162 6.46703 22.0212 0.372041 14.5 0.363281Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3651 9.67321L14.5931 20.2201C14.4078 20.466 14.1314 20.6271 13.8261 20.6673C13.5207 20.7074 13.2121 20.6232 12.9695 20.4335L7.41956 15.9963C6.92982 15.6044 6.85052 14.8897 7.24244 14.3999C7.63436 13.9102 8.34909 13.8309 8.83883 14.2228L13.4668 17.9254L20.537 8.33001C20.7689 7.98211 21.1732 7.78976 21.5894 7.82933C22.0055 7.86891 22.3663 8.134 22.5284 8.51936C22.6906 8.90473 22.6278 9.34801 22.3651 9.67321Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/feature.4f369260dfa0a29ede988d630566cbf3.svg";
export { ForwardRef as ReactComponent };